<span class="message-bubble">

  @if (this.message.role !== 'botcard') {
  <div
    #messageWrapper
    class="row message px-3 pt-5"
    [ngClass]="{
      'text-end': this.message.role === 'user',
      'text-start': this.message.role === 'assistant',
      'highlight': this.isHighlighted()
    }"
  >
    @if (this.message.role === 'assistant' && this.avatarimage.getBotAvatar() !== '') {
    <div class="col-auto gx-0 align-self-end">
      <img
        class="rounded-circle me-2 avatar-assistant"
        [src]="this.avatarimage.getBotAvatar()"
        alt=""
        width="40"
        height="40"
      >
    </div>
    }
    <div class="col gx-0">
      <span
        #bubble
        class="bubble bubble-{{this.message.role}}  text-start"
        [ngClass]="{'bubble-bypass': this.message.bypass}"
        [hidden]="this.message.role === 'assistant' && this.hasButtonsAtEnd && !this.messageContentWithLinks.trim()"
      >
        @if (message.reasoning && message.reasoning !== '') {
        <div
          data-bs-toggle="collapse"
          [attr.data-bs-target]="'#reasoning-' +message._id"
          aria-expanded="false"
          [attr.aria-controls]="'reasoning-' +message._id"
          class="text-secondary cursor-pointer"
        >
          Argumentation:<i class="ri-arrow-down-s-line"></i>
        </div>
        <div
          class="collapse mb-2"
          [id]="'reasoning-' +message._id"
        >
          <div class="text-secondary">
            {{message.reasoning}}
          </div>
        </div>
        }
        @if (this.message.role === 'user') {
        <markdown [data]="this.getUserMessageFormatted(this.message.content)"></markdown>
        }
        @if (this.message.role === 'assistant') {
        <div class="position-relative">
          <markdown [data]="this.messageContentWithLinks"></markdown>
        </div>
        }
      </span>
      @if (this.message.role==='assistant') {
      <div
        class="row align-items-center animate__animated animate__fadeInUp animate__faster bubble-addons"
        style="margin-left: 2px;"
      >
        @if (voiceOutputActive()) {
        <div class="col-auto p-0">
          <app-audio-btn
            [msg]="cleanMessageContent()"
            [botId]="this.bot()._id"
            [voice]="this.bot().voiceConfig.id"
          >
          </app-audio-btn>
        </div>
        }
        @if (this.bot().messageCopyChatActive) {
        <div class="col-auto px-1">
          <button
            type="button"
            class="feedback icon-btn-reset"
            aria-label="Nachricht kopieren"
            i18n-aria-label="@@message-copy"
            (click)="this.copyMsgToClipboard(cleanMessageContent())"
          >
            <i
              class="ri-file-copy-line cursor-pointer"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        }
        @if (!this.isThinking()) {
        <div class="col-auto px-1">
          @if (this.enableFeedback()) {
          <span class="feedback ">
            <button
              type="button"
              class="icon-btn-reset"
              aria-label="Positives Feedback geben"
              i18n-aria-label="@@message-feedback-positive"
              (click)="this.sendFeedback.emit({remark: this.remark() === 'thumbsup' ? '' : 'thumbsup',  msgId: this.message._id})"
            >
              <i
                [ngClass]="{
          'ri-thumb-up-line': this.remark() !== 'thumbsup',
          'ri-thumb-up-fill': this.remark() === 'thumbsup'
        }"
                class="cursor-pointer"
                aria-hidden="true"
              ></i>
            </button>
            <button
              type="button"
              class="icon-btn-reset ms-1"
              aria-label="Negatives Feedback geben"
              i18n-aria-label="@@message-feedback-negative"
              (click)="this.sendFeedback.emit({remark: this.remark() === 'thumbsdown' ? '' : 'thumbsdown', msgId: this.message._id})"
            >
              <i
                [ngClass]="{
                    'ri-thumb-down-line': this.remark() !== 'thumbsdown',
                    'ri-thumb-down-fill': this.remark() === 'thumbsdown'
                  }"
                class="cursor-pointer"
                aria-hidden="true"
              ></i>
            </button>
          </span>
          }
        </div>
        }
        <div class="col p-0"></div>
        @if (this.enableDeletion() && !this.isThinking()) {
        <div class="col-auto p-0">
          @if (this.debugMode()) {
          <i
            class="ri-bug-2-line"
            style="cursor: pointer;"
            (click)="this.highlightEntry()"
          ></i>
          }
          @if (!this.deleting) {
          <i
            class="ri-close-line text-danger ms-1"
            (click)="deleteMessageAndLoad(this.message)"
          ></i>
          }
          @if (this.deleting) {
          <div
            class="spinner-border spinner-border-sm text-danger"
            role="status"
          >
            <span
              class="visually-hidden"
              i18n="@@loading"
            >Loading...</span>
          </div>
          }
        </div>
        }
      </div>
      }
      @if (this.message.role==='user' && this.enableDeletion()) {
      <div class="text-end">
        @if (this.debugMode()) {
        <i
          class="ri-bug-2-line"
          style="cursor: pointer;"
          (click)="this.highlightEntry()"
        ></i>
        }
        @if (!this.deleting) {
        <i
          class="ri-close-line text-danger ms-1"
          (click)="deleteMessageAndLoad(this.message)"
          style="cursor: pointer;"
        ></i>
        }
        @if (this.deleting) {
        <div
          class="spinner-border spinner-border-sm text-danger"
          role="status"
        >
          <span
            class="visually-hidden"
            i18n="@@loading"
          >Loading...</span>
        </div>
        }
      </div>
      }
    </div>
    @if (this.message.role === 'user' && this.avatarimage.getUserAvatar() !== '') {
    <div class="col-auto gx-0 align-self-end">
      <img
        class="rounded-circle ms-2 avatar-user"
        [src]="this.avatarimage.getUserAvatar()"
        alt=""
        width="40"
        height="40"
      >
    </div>
    }
  </div>
  }
  @if (this.hasButtonsAtEnd) {
  <div class="ms-2">
    <span class="more-options-text">Mögliche Optionen:</span>
    <div
      class="row mt-2"
      style="max-width: 90%"
    >
      @for (button of this.buttons; track button) {
      <div class="col-auto pe-0 mb-2"><span
          class="btn btn-light text-primary btn-sm message-button text-start">{{button}}</span></div>
      }
    </div>
  </div>
  }
</span>